import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const billingSelector = createSelector(stateSelector, (state) => state.billingInformation);

const paginationSelector = createSelector(stateSelector, (state) => {
  return state.usersData;
});

const billingPageSelector = createSelector(stateSelector, (state) => state.currentPage);

const invoicesSelector = createSelector(stateSelector, (state) => state.invoices);

const editingCardLoadingSelector = createSelector(stateSelector, (state) => state.editingCardLoading);

const onBoardingCardLoadingSelector = createSelector(stateSelector, (state) => state.onBoardingCardLoading);

const billingEditModeSelector = createSelector(stateSelector, (state) => state.billingEditMode);

const isLoadingBillingSelector = createSelector(stateSelector, (state) => state.isLoadingBilling);

const isLoadingInvoicesSelector = createSelector(stateSelector, (state) => state.isLoadingInvoices);

const paymentMethodSelector = createSelector(stateSelector, (state) => state.paymentMethod);

const stripeTokenSelector = createSelector(billingSelector, (state) => state.stripe_token);

export const BillingSelectors = {
  editingCardLoadingSelector,
  isLoadingBillingSelector,
  isLoadingInvoicesSelector,
  billingSelector,
  invoicesSelector,
  billingEditModeSelector,
  paginationSelector,
  billingPageSelector,
  paymentMethodSelector,
  stripeTokenSelector,
  onBoardingCardLoadingSelector,
};
